import { render, staticRenderFns } from "./LowStateTypeDashboardStats.vue?vue&type=template&id=749b9fb4&scoped=true"
import script from "./LowStateTypeDashboardStats.vue?vue&type=script&lang=js"
export * from "./LowStateTypeDashboardStats.vue?vue&type=script&lang=js"
import style0 from "./LowStateTypeDashboardStats.vue?vue&type=style&index=0&id=749b9fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749b9fb4",
  null
  
)

export default component.exports